import { Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const cards = [
  {
    title: "Professional service",
    text: "Every job carried out carefully and tested before we leave — big or small.",
  },
  {
    title: "Domestic & commercial",
    text: "Homes, rental properties, shops and offices — the same standard on every visit.",
  },
  {
    title: "Clear communication",
    text: "You'll know what's happening, when, and what it costs — before any work starts.",
  },
];

const Trust = () => (
  <section data-testid="trust-section" className="bg-[#FAFAFA] py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        <Reveal className="md:col-span-5 bg-slate-900 rounded-md p-9 md:p-12 flex flex-col justify-between min-h-[320px]">
          <div>
            <Overline light>Why it matters</Overline>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.1]">
              Professional Work. Straightforward Service.
            </h2>
          </div>
          <p className="mt-8 text-base leading-relaxed text-slate-300">
            Most people just want an electrician who answers the phone, turns up
            when they say they will, and does the job properly. That's the
            standard we work to on every visit.
          </p>
        </Reveal>
        <Reveal
          delay={0.1}
          className="md:col-span-7 bg-white border border-slate-200 rounded-md divide-y divide-slate-200 flex flex-col justify-center"
        >
          {cards.map((c) => (
            <div
              key={c.title}
              data-testid={`trust-item-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="flex items-start gap-5 p-7 md:p-8"
            >
              <span className="mt-0.5 w-8 h-8 shrink-0 bg-amber-400 rounded-md flex items-center justify-center">
                <Check className="w-5 h-5 text-slate-900" strokeWidth={3} />
              </span>
              <div>
                <h3 className="text-xl font-bold text-slate-900">{c.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{c.text}</p>
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);

export default Trust;
